import { takeLatest, put, call } from 'redux-saga/effects';
import {
  GET_EDIT_MISSING_SENDER_INFO_FORM,
  GET_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
  GET_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
  VERIFY_EDIT_MISSING_SENDER_INFO_FORM,
  VERIFY_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
  VERIFY_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
  SUBMIT_EDIT_MISSING_SENDER_INFO_FORM,
  SUBMIT_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
  SUBMIT_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
} from "../Assets/Constant/MissingSenderInfoForm";

import { getBaseUrl, COMPLIANCE } from '../Network/baseUrl';
import http from '../Network/http';

function* getEditMissingSenderInfo(data) {
  const { source, sourceUniqueId } = data;
  const region = localStorage.getItem('region');
  try {
    const apiConfig = {
      method: 'get',
      baseURL: getBaseUrl(COMPLIANCE),
      url: `/missing-user-info/beneficiary-bank/${source}/${sourceUniqueId}/edit`,
      params: {
        region,
      },
    };
    const res = yield call(http, apiConfig);
    const { data: { data } } = res;

    yield put({
      type: GET_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
      data,
    });
  } catch (e) {
    yield put({
      type: GET_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
      error: e,
    });
  }
}

function* verifyMissingSenderInfoFormInput(item) {
  try {
    const region = localStorage.getItem('region');
    const apiConfig = {
      method: 'post',
      baseURL: getBaseUrl(COMPLIANCE),
      url: '/missing-user-info/verify-input',
      data: JSON.stringify({
        ...item.data,
        entity_type: item.entity_type,
        region
      })
    };
    const res = yield call(http, apiConfig);
    const { data: { data, errors } } = res;
    if (res.status === 200) {
      yield put({
        type: VERIFY_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
        data,
        target: item.data.__target
      });
    } else {
      yield put({
        type: VERIFY_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
        data,
        target: item.data.__target,
        errors
      });
    }

  } catch (e) {
    console.log('error', e);
  }
}

function* submitEditMissingSenderInfo(item) {
  const { source, sourceUniqueId } = item;
  try {
    const region = localStorage.getItem('region');
    const apiConfig = {
      method: 'post',
      baseURL: getBaseUrl(COMPLIANCE),
      url: `/missing-user-info/beneficiary-bank/${source}/${sourceUniqueId}`,
      params: {
        region
      },
      data: JSON.stringify({
        ...item.data,
        entity_type: item.entity_type,
      })
    };
    const res = yield call(http, apiConfig);

    const { data: { data, errors } } = res;
    if (res.status === 200) {
      yield put({
        type: SUBMIT_EDIT_MISSING_SENDER_INFO_FORM_SUCCESS,
        data,
      });
    } else {
      yield put({
        type: SUBMIT_EDIT_MISSING_SENDER_INFO_FORM_FAIL,
        data,
        errors
      });
    }

  } catch (e) {
    console.log('error', e);
  }
}

export function* watchMissingSenderInfoForm() {
  yield takeLatest(GET_EDIT_MISSING_SENDER_INFO_FORM, getEditMissingSenderInfo);
  yield takeLatest(VERIFY_EDIT_MISSING_SENDER_INFO_FORM, verifyMissingSenderInfoFormInput);
  yield takeLatest(SUBMIT_EDIT_MISSING_SENDER_INFO_FORM, submitEditMissingSenderInfo);
}
